module.exports = __webpack_public_path__ + "img/wuLong2.80509a72.png";